import React, { useState, useEffect } from 'react';
import { useUsers } from '../hooks/useDatabase';

const UserPage = ({ onLogout, currentUser }) => {
  const { users, loading, error, createUser, updateUser, deleteUser, fetchUsers } = useUsers();
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    position: '',
    role: 'user',
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  // โหลดข้อมูลผู้ใช้เมื่อ component เริ่มต้น
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let result;
      if (editingUser) {
        // อัปเดตผู้ใช้
        result = await updateUser(editingUser.id, formData);
      } else {
        // เพิ่มผู้ใช้ใหม่
        result = await createUser(formData);
      }

      if (result.success) {
        // รีเซ็ตฟอร์ม
        setFormData({
          name: '',
          phone: '',
          email: '',
          position: '',
          role: 'user',
          username: '',
          password: ''
        });
        setShowForm(false);
        setEditingUser(null);

        // แสดงข้อความสำเร็จ
        alert(editingUser ? 'อัปเดตข้อมูลผู้ใช้สำเร็จ' : 'เพิ่มผู้ใช้ใหม่สำเร็จ');

        // รีเฟรชข้อมูล
        await fetchUsers();
      } else {
        alert(result.error || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล');
      }
    } catch (error) {
      console.error('Error saving user:', error);
      alert('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      name: user.name,
      phone: user.phone,
      email: user.email,
      position: user.position,
      role: user.role,
      username: user.username,
      password: user.password
    });
    setShowForm(true);
  };

  const handleDelete = async (userId) => {
    if (window.confirm('คุณแน่ใจหรือไม่ที่จะลบผู้ใช้นี้?')) {
      try {
        await deleteUser(userId);
        await fetchUsers();
      } catch (error) {
        console.error('Error deleting user:', error);
        alert('เกิดข้อผิดพลาดในการลบข้อมูล');
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingUser(null);
    setFormData({
      name: '',
      phone: '',
      email: '',
      position: '',
      role: 'user',
      username: '',
      password: ''
    });
  };



  if (loading) {
    return (
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container-fluid mt-4">
        <div className="alert alert-danger" role="alert">
          เกิดข้อผิดพลาด: {error}
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0">
              <i className="fas fa-users me-2"></i>
              จัดการผู้ใช้งาน
            </h2>
            <button
              className="btn btn-primary"
              onClick={() => setShowForm(true)}
            >
              <i className="fas fa-plus me-2"></i>
              เพิ่มผู้ใช้ใหม่
            </button>
          </div>



          {/* ฟอร์มเพิ่ม/แก้ไขผู้ใช้ */}
          {showForm && (
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="mb-0">
                  {editingUser ? 'แก้ไขข้อมูลผู้ใช้' : 'เพิ่มผู้ใช้ใหม่'}
                </h5>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">ชื่อ-นามสกุล *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">เบอร์โทรศัพท์ *</label>
                      <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">อีเมล *</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">ตำแหน่ง *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="position"
                        value={formData.position}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">บทบาท *</label>
                      <select
                        className="form-select"
                        name="role"
                        value={formData.role}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="user">ผู้ใช้งาน</option>
                        <option value="staff">พนักงาน</option>
                        <option value="stock">เจ้าหน้าที่สต๊อก</option>
                        <option value="service">ฝ่ายบริการ</option>
                        <option value="admin">ผู้ดูแลระบบ</option>
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">ชื่อผู้ใช้ *</label>
                      <input
                        type="text"
                        className="form-control"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">รหัสผ่าน *</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          name="password"
                          value={formData.password}
                          onChange={handleInputChange}
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <button type="submit" className="btn btn-primary me-2">
                      <i className="fas fa-save me-2"></i>
                      {editingUser ? 'บันทึกการแก้ไข' : 'เพิ่มผู้ใช้'}
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                      <i className="fas fa-times me-2"></i>
                      ยกเลิก
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* ตารางแสดงผู้ใช้ */}
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">รายการผู้ใช้งาน ({users.length} คน)</h5>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>ชื่อ-นามสกุล</th>
                      <th>อีเมล</th>
                      <th>เบอร์โทรศัพท์</th>
                      <th>ตำแหน่ง</th>
                      <th>บทบาท</th>
                      <th>ชื่อผู้ใช้</th>
                      <th>การจัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center py-4">
                          <i className="fas fa-users fa-3x text-muted mb-3"></i>
                          <p className="text-muted mb-0">ไม่พบข้อมูลผู้ใช้</p>
                        </td>
                      </tr>
                    ) : (
                      users.map((user) => (
                        <tr key={user.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="avatar-sm bg-primary rounded-circle d-flex align-items-center justify-content-center me-2">
                                <i className="fas fa-user text-white"></i>
                              </div>
                              <div>
                                <div className="fw-bold">{user.name}</div>
                                {currentUser && currentUser.id === user.id && (
                                  <small className="text-success">
                                    <i className="fas fa-check-circle me-1"></i>
                                    ผู้ใช้ปัจจุบัน
                                  </small>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>{user.email}</td>
                          <td>{user.phone}</td>
                          <td>{user.position}</td>
                          <td>
                            <span className={`badge ${user.role === 'admin' ? 'bg-danger' :
                              user.role === 'staff' ? 'bg-info' :
                                user.role === 'stock' ? 'bg-warning' :
                                  user.role === 'service' ? 'bg-secondary' : 'bg-primary'
                              }`}>
                              {user.role === 'admin' ? 'ผู้ดูแลระบบ' :
                                user.role === 'staff' ? 'พนักงาน' :
                                  user.role === 'stock' ? 'เจ้าหน้าที่สต๊อก' :
                                    user.role === 'service' ? 'ฝ่ายบริการ' : 'ผู้ใช้งาน'}
                            </span>
                          </td>
                          <td>
                            <code>{user.username}</code>
                          </td>
                          <td>
                            <div className="btn-group" role="group">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => handleEdit(user)}
                                title="แก้ไข"
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDelete(user.id)}
                                title="ลบ"
                                disabled={currentUser && currentUser.id === user.id}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPage;